
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { createStore , combineReducers } from 'redux';
import  UIreducer from './store/reducers/reducer';
import { Provider } from 'react-redux';
import "./assets/menu.css"
import "./assets/style.css"
import "./assets/App.css";

const rootReducer = combineReducers({
    ui_red : UIreducer,
});

const store = createStore(rootReducer);
const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

